(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-virtualized"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-virtualized"], factory);
	else if(typeof exports === 'object')
		exports["reactVirtualizedTree"] = factory(require("react"), require("react-virtualized"));
	else
		root["reactVirtualizedTree"] = factory(root["React"], root["ReactVirtualized"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_17__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition